export const FirebaseConfig = {
	"projectId": "ohmyride-8778c",
	"appId": "1:500732671356:web:be55b0192c5e5daa66e0f9",
	"databaseURL": "https://ohmyride-8778c-default-rtdb.firebaseio.com",
	"storageBucket": "ohmyride-8778c.firebasestorage.app",
	"apiKey": "AIzaSyBHxbCcAwDW71Pea7iLs67dbgy2vOTBHLY",
	"authDomain": "ohmyride-8778c.firebaseapp.com",
	"messagingSenderId": "500732671356",
	"measurementId": "G-ET4KXFLCRP",
	"projectNumber": "500732671356",
	"version": "2"
};